import type { RoadmapConfidence } from '@/api/types/catalogue'
import { ROADMAP_CONFIDENCE_LABEL } from '@/api/types/catalogue'
import { capsOf, itemDependencies, rollup, type Dependency } from '@/lib/catalogue/engine'
import type { ModuleCtx } from '@/lib/readiness/module'

export const confidenceText = (c: RoadmapConfidence | null | undefined) => (c ? ROADMAP_CONFIDENCE_LABEL[c] : '—')

// Figures shared by the Overview tile, the catalogue KPIs and the tracker.
export function dependencySummary(m: ModuleCtx) {
  const { catalogue, mscope } = m
  const inUseIds = Array.from(new Set(catalogue.usage.map((u) => u.technology_id)))
  const inUse = catalogue.technologies.filter((t) => inUseIds.includes(t.id))
  const counts = { pqc_ready: 0, partial: 0, roadmap: 0, other: 0 }
  inUse.forEach((t) => {
    const r = rollup(capsOf(t.id, catalogue.capabilities))
    if (r === 'pqc_ready' || r === 'partial' || r === 'roadmap') counts[r]++
    else counts.other++
  })
  const gated: Dependency[] = mscope ? mscope.items.flatMap((i) => itemDependencies(i, mscope, catalogue.usage, catalogue.technologies, catalogue.capabilities)).filter((d) => d.gated) : []
  const dated = gated.filter((d) => d.roadmap_date).sort((a, b) => (a.roadmap_date ?? '').localeCompare(b.roadmap_date ?? ''))
  return {
    inUse,
    vendors: new Set(inUse.map((t) => t.vendor)).size,
    counts,
    gated,
    gatedItems: Array.from(new Set(gated.map((g) => g.item.id))).length,
    earliest: dated[0] ?? null,
    latest: dated[dated.length - 1] ?? null,
    unmatched: catalogue.unmatched,
  }
}
